/**
 * URL-hash keys for the clients feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const CLIENTS_HASH = {
  /** `#create` — ClientFormDialog in create mode. */
  create: 'create',
  /** `#edit/<id>` — ClientFormDialog editing a specific client. */
  edit: 'edit',
  /** `#view/<id>` — ClientDetailDialog for a specific client. */
  view: 'view',
  /** `#delete/<id>` — single-client delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type ClientsHashKey = (typeof CLIENTS_HASH)[keyof typeof CLIENTS_HASH];
